import { Link, Typography } from "@mui/material";
import { Links, SystemStatus } from "src/constants";
import { FeedItemDto, FeedItemTaskItemValueDto } from "src/http";

interface Props {
  feedItem: FeedItemDto;
}

const TaskItemParentPropertyChange = (props: Props) => {
  const taskItem = props.feedItem.propertyChange!.value as FeedItemTaskItemValueDto;
  let changeTypeString = "";

  if ([SystemStatus.Created, SystemStatus.Edited].includes(props.feedItem.propertyChange!.changeType)) {
    changeTypeString = " changed context to task ";
  }

  if (props.feedItem.propertyChange!.changeType === SystemStatus.Deleted) {
    changeTypeString = " removed context to task ";
  }

  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span>{changeTypeString}</span>
      <Link href={Links.TaskItemDetail(taskItem.taskItemGuid)} sx={{ fontWeight: "bold" }}>
        {taskItem.description}
      </Link>
    </Typography>
  );
};

export { TaskItemParentPropertyChange };
